import React from "react";
import userExample from "../user/UserExample";

function EmailUser() {
  return (
    <section className="content">
      <div className="card">
        <div className="card-body" id="fill-info-user">
          <div className="d-flex flex-row">
            <div className="pl-2">
              <span>
                <i className="fas fa-check-circle text-success"></i>
              </span>
            </div>
            <div>
              <div>
                <p className="m-0">کاربر محترم </p>
              </div>
              <div className="pt-3">
                <span>ایمیل : </span>
                <span>{userExample.email}</span>
              </div>
              <div className="pt-3">
                <p className="m-0">ایمیل شما با موفقیت تایید شد.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EmailUser;
